// extracted by mini-css-extract-plugin
export default {"langSelector":"intro_langSelector__wBdsa","introALikeGradient":"intro_introALikeGradient__wY0xe"};